/**
 * H5「文字 / 调整」入口的显示与可用策略
 *
 * 背景：
 *   图库级字段 support_text_edit / support_graphic_drag 原本用于控制「文字」「调整」两个入口是否可用。
 *   当前业务要求：只要客户开启图库扩展字段功能（gallery_extra_fields_enabled = 1），
 *   就直接强制隐藏这两个入口，不再读图库级字段。
 *
 * 如何恢复为「按图库配置控制」：
 *   把 MODE 改成 'GALLERY_CONFIG'，入口会恢复显示，并由图库级字段决定是否置灰；
 *   如果希望「按图库配置隐藏」而不是置灰，把 GALLERY_CONFIG 分支返回的 visible 改成 enabled 即可。
 *
 * 返回值约定：
 *   visible: false → 模板里用 v-if 隐藏入口
 *   enabled: false → 用 disabled 样式置灰，并在点击时拦截
 */
const MODE = 'FORCE_HIDE' // 'FORCE_HIDE'：flag=1 时强制隐藏 | 'GALLERY_CONFIG'：按图库级字段控制

/**
 * 「文字」入口状态
 * @param {Object} options
 * @param {Boolean} options.galleryExtraFieldsEnabled 客户是否开启图库扩展字段功能
 * @param {Boolean} options.supportTextEdit 图库是否支持文字编写
 * @returns {{visible: Boolean, enabled: Boolean}}
 */
export function getTextEntryState(options) {
	const opts = options || {}
	if (opts.galleryExtraFieldsEnabled && MODE === 'FORCE_HIDE') {
		return { visible: false, enabled: false }
	}
	return { visible: true, enabled: opts.supportTextEdit !== false }
}

/**
 * 「调整」（Custom）入口状态
 * @param {Object} options
 * @param {Boolean} options.galleryExtraFieldsEnabled 客户是否开启图库扩展字段功能
 * @param {Boolean} options.supportGraphicDrag 图库是否支持图形拖拽
 * @returns {{visible: Boolean, enabled: Boolean}}
 */
export function getCustomEntryState(options) {
	const opts = options || {}
	if (opts.galleryExtraFieldsEnabled && MODE === 'FORCE_HIDE') {
		return { visible: false, enabled: false }
	}
	return { visible: true, enabled: opts.supportGraphicDrag !== false }
}
